import classNames from 'classnames'

import type { ReactElement } from 'react'

import './styles.scss'

interface Props {
  className?: string
  count: number | null
}

const FilterCounter = ({ className, count }: Props): ReactElement => {
  return (
    <div className={classNames('filter-counter-component', className)}>
      <span>{count}</span>
    </div>
  )
}

export default FilterCounter
